import { ClientTicketStatus } from '@bustickus/models-client';
import { Flex } from 'components';
import { getTicketStatusClass, getTicketStatusIcon, getTicketStatusText } from './helpers';
import './style.scss';
import { Icon } from 'shared/components';

interface IProps {
  status: ClientTicketStatus;
}

function TicketStatus(props: IProps) {
  const colorClass = getTicketStatusClass(props.status);

  return (
    <Flex
      gap={5}
      className={`ticket-status-O4t5 ${colorClass}`}
    >
      <Icon>{getTicketStatusIcon(props.status)}</Icon>
      <span>{getTicketStatusText(props.status)}</span>
    </Flex>
  );
}

export default TicketStatus;
